angular.module('env.data.rest.model.representationModel', [])

    .factory('RepresentationModel', function ($log, $q, $injector, RepresentationModelFieldTypes) {

        /**
         * Representation (client-side) model
         * @param {ModelDefinition} modelDefinition model definition
         * @param {Object} [proto] plain prototype of new model
         * @constructor
         */
        function RepresentationModel(modelDefinition, proto) {

            /**
             * Model Definition
             * @type {ModelDefinition}
             */
            this._modelDefinition = modelDefinition;

            this._proto = proto;

            this._rest = $injector.get("rest", "RepresentationModel");

            /**
             * Current state of representation model
             * @type {Object}
             */
            this.$model = this._modelDefinition.newModel(); // basic init

            /**
             * Clean(non-changed) client-side object
             * @type {Object}
             */
            this._originalModel = {};

            /**
             * Server-side original model. Do not change this model!
             * @type {Object}
             */
            this._serverObject = {};

            /**
             * Hook for instance detecting
             */
            this.isRepresentationModel = true;

            this._initProto();
            this._initCustomMethods();
        }

        RepresentationModel.prototype._initProto = function () {
            var _this = this;
            if (this._proto) {
                _.forEach(this._modelDefinition.getFields(), function (fieldDef) {
                    if (!fieldDef.subResource) {
                        _this.$model[fieldDef.name] = _.clone(_this._proto[fieldDef.name]);
                    }
                });
            }
        }

        RepresentationModel.prototype._initCustomMethods = function () {
            var _this = this;
            _.forEach(this._modelDefinition.getMethods(), function (method, methodName) {
                if (!_this[methodName]) {
                    var localMethod = method;
                    _this[methodName] = function () {
                        return localMethod.apply(_this, [_this._rest, _this].concat([].slice.call(arguments)));
                    };
                } else {
                    $log.warn(_.str.sprintf("Can't init custom method %s. Field or method with such name already exists. Check %s model definition", methodName, _this._modelDefinition.getType()));
                }
            });
        }

        /**
         * Async initialization of model (with sub resources initialization)
         * @param {Object} [dtoObject] server-side object
         * @returns {!Promise.<RepresentationModel>} promise of current model
         */
        RepresentationModel.prototype.initAsync = function (dtoObject) {
            var _this = this;
            _this._serverObject = dtoObject;
            var promises = [];
            _.forEach(_.sortBy(this._modelDefinition.getFields(), "subResource"), function (fieldDef) {
                promises.push(_this._initFieldAsync(fieldDef));
            });
            return $q.all(promises).then(function () {
                _this._originalModel = _this._deepCloneClientModel(_this.$model);
                return _this;
            });
        }

        /**
         * Deep clone for every field except RepresentationModels
         * @param model
         * @return {*}
         */
        RepresentationModel.prototype._deepCloneClientModel = function (model) {
            var _this = this;
            var clone = _.clone(model);
            _.each(clone, function (value, key) {
                if (value == null) {
                    clone[key] = value;
                } else if (_.isArray(value)) {
                    if (_.every(value, e => e == null || e.isRepresentationModel)) {
                        clone[key] = value.slice();
                    } else {
                        clone[key] = _this._deepCloneClientModel(value);
                    }
                } else if (value.isRepresentationModel) {
                    clone[key] = value;
                } else if (_.isPlainObject(value)) {
                    clone[key] = _this._deepCloneClientModel(value);
                } else if (_.isDate(value)) {
                    clone[key] = new Date(value.getTime());
                }
            });
            return clone;
        }

        /**
         * Async initialization of model field
         * @param {FieldDefinition} fieldDefinition field definition
         * @returns {!Promise.<Object>} promise of initialized field
         */
        RepresentationModel.prototype._initFieldAsync = function (fieldDefinition) {
            var _this = this;
            var deferred = $q.defer();
            if (fieldDefinition.subResource) {
                var init = fieldDefinition.get(_this._rest, _this, _this._serverObject, fieldDefinition);
                if (init && _.isPromise(init)) {
                    init.then(
                        function (subResource) {
                            deferred.resolve(_this._setField(fieldDefinition, subResource));
                        },
                        function (err) {
                            deferred.reject(err);
                        });
                } else if (init && _.isFunction(init)) {
                    deferred.resolve(fieldDefinition, _this._setField(fieldDefinition, init()));
                } else {
                    deferred.resolve(fieldDefinition, _this._setField(fieldDefinition, init));
                }
            } else {
                if (_this._serverObject) {
                    _this._setField(fieldDefinition, _this._serverObject[fieldDefinition.serverName]);
                }
                deferred.resolve(_this.$model[fieldDefinition.name]);
            }

            return deferred.promise;
        }

        RepresentationModel.prototype.saveAndTransform = function () {
            var _this = this;
            var promises = [];
            _.forEach(this._modelDefinition.getFields(), function (fieldDef) {
                if (fieldDef.save) {
                    var p = fieldDef.save(_this._rest, _this);
                    if (p && _.isPromise(p)) {
                        promises.push(p);
                    }
                }
            });

            return $q.all(promises).then(
                function (resp) {
                    _this._buildOriginalModel();
                    _this._toServerModel();
                    return _this._serverObject;
                }
            );
        }

        RepresentationModel.prototype._buildOriginalModel = function () {
            var _this = this;
            _.clearObject(_this._originalModel);
            _.forEach(_this._modelDefinition.getFields(), function (fieldDef) {
                if (!fieldDef.subResource) {
                    _this._originalModel[fieldDef.serverName] = _this.$model[fieldDef.name];
                }
            });
            return _this._originalModel;
        }

        /**
         * Transform representation model to server-side model
         * @returns {Object} copy of server-side model
         */
        RepresentationModel.prototype._toServerModel = function () {
            var _this = this;
            _this._serverObject = _this._serverObject || {};
            var newServerObject = _.cloneDeep(_this._serverObject);

            _.forEach(_this._modelDefinition.getFields(), function (fieldDef) {
                if (!fieldDef.subResource) {
                    newServerObject[fieldDef.serverName] = _this._encode(fieldDef, _this.$model[fieldDef.name]);
                }
            });
            _.resetObject(_this._serverObject, newServerObject);
            return _this._serverObject;
        }

        /**
         * Set field of the model
         * @param {FieldDefinition} fieldDefinition field definition
         * @param {*} [value] server object field value
         * @returns {*} field of the model
         */
        RepresentationModel.prototype._setField = function (fieldDefinition, value) {
            this.$model[fieldDefinition.name] = this._decode(fieldDefinition, value);
            return this.$model[fieldDefinition.name];
        }

        RepresentationModel.prototype._encode = function (fieldDefinition, value) {
            var _this = this;
            var encodedValue;
            var type = fieldDefinition.type;

            try {
                if (type == RepresentationModelFieldTypes.DYNAMIC) {
                    encodedValue = _.cloneDeep(value);
                } else if (type == RepresentationModelFieldTypes.FLOAT) {
                    encodedValue = _.clone(value);
                } else if (type == RepresentationModelFieldTypes.INTEGER) {
                    encodedValue = _.clone(value);
                } else if (type == RepresentationModelFieldTypes.STRING) {
                    encodedValue = _.clone(value);
                } else if (type == RepresentationModelFieldTypes.BOOLEAN) {
                    encodedValue = _.clone(value);
                } else if (type == RepresentationModelFieldTypes.DATE) {
                    if (value && _.isDate(value)) {
                        encodedValue = value.toISOString();
                    } else {
                        encodedValue = _.clone(value);
                    }
                } else if (type == RepresentationModelFieldTypes.ARRAY) {
                    encodedValue = _.clone(value);
                } else if (type == RepresentationModelFieldTypes.MODEL) {
                    encodedValue = value;
                }
            } catch (error) {
                $log.warn(_.str.sprintf("Encode of field crashed. Model type: %s; Field name: %s; Server value: %s", _this.getType(), fieldDefinition.name, value), error);
                encodedValue = null;
            }

            if (fieldDefinition.encode) {
                try {
                    return fieldDefinition.encode(value, encodedValue, _this, _this._rest);
                } catch (error) {
                    $log.warn(_.str.sprintf("Custom encode function crashed. Model type: %s; Field name: %s; Server value: %s", _this.getType(), fieldDefinition.name, value), error);
                }
            }
            return encodedValue;
        }

        RepresentationModel.prototype._decode = function (fieldDefinition, value) {
            var _this = this;
            var decodedValue;
            var type = fieldDefinition.type;

            try {
                if (type == RepresentationModelFieldTypes.DYNAMIC) {
                    decodedValue = _.cloneDeep(value);
                } else if (type == RepresentationModelFieldTypes.FLOAT) {
                    decodedValue = parseFloat(value);
                } else if (type == RepresentationModelFieldTypes.INTEGER) {
                    decodedValue = parseInt(value);
                } else if (type == RepresentationModelFieldTypes.STRING) {
                    decodedValue = value ? value.toString() : null;
                } else if (type == RepresentationModelFieldTypes.BOOLEAN) {
                    decodedValue = !!(value && (value == true || value.toLowerCase() == "true" || value == "1" || value.toLowerCase() == "yes"));
                } else if (type == RepresentationModelFieldTypes.DATE) {
                    if (value) {
                        if (_.isString(value)) {
                            try {
                                if (value.indexOf('Z') < 0) { // anyway we support only ISO strings
                                    decodedValue = new Date(value + 'Z');
                                } else {
                                    decodedValue = new Date(value);
                                }
                            } catch (error) {
                                $log.warn(_.str.sprintf(
                                        "Incorrect date format in server object. Model type: %s; Field name: %s; Server value: %s",
                                        _this.getType(),
                                        fieldDefinition.name,
                                        value),
                                    error);
                            }
                        } else if (_.isDate(value)) {
                            decodedValue = value;
                        } else {
                            $log.warn(_.str.sprintf(
                                "Incorrect date format in server object. Model type: %s; Field name: %s; Server value: %s",
                                _this.getType(),
                                fieldDefinition.name,
                                value));
                        }
                    }
                } else if (type == RepresentationModelFieldTypes.ARRAY) {
                    decodedValue = (!value || !_.isArray(value)) ? [] : _.clone(value);
                } else if (type == RepresentationModelFieldTypes.MODEL) {
                    decodedValue = value;
                }
            } catch (error) {
                $log.warn(_.str.sprintf("Decoding of field crashed. Model type: %s; Field name: %s; Server value: %s", _this.getType(), fieldDefinition.name, value), error);
                decodedValue = null;
            }

            if (fieldDefinition.decode) {
                try {
                    return fieldDefinition.decode(value, decodedValue, _this, _this._rest);
                } catch (error) {
                    $log.warn(_.str.sprintf("Custom decode function crashed. Model type: %s; Field name: %s; Server value: %s", _this.getType(), fieldDefinition.name, value), error);
                }
            }
            return decodedValue;
        }

        /**
         * Get model type
         * @returns {string}
         */
        RepresentationModel.prototype.getType = function () {
            return this._modelDefinition.getType();
        }

        /**
         * Get model definition
         * @returns {ModelDefinition}
         */
        RepresentationModel.prototype.getDefinition = function () {
            return this._modelDefinition;
        }

        /**
         * Get model ID
         * @returns {string}
         */
        RepresentationModel.prototype.getId = function () {
            return this.$model[this._modelDefinition.getIdPropertyName()];
        }

        /**
         * Get original version of server-side model, if exists
         * @returns {*}
         */
        RepresentationModel.prototype.getServerModel = function () {
            return !this._serverObject ? null : _.cloneDeep(this._serverObject);
        }

        /**
         * Get original client-side model
         * @returns {*}
         */
        RepresentationModel.prototype.getOriginalModel = function () {
            return _.cloneDeep(this._originalModel);
        }

        /**
         * Reset changes
         */
        RepresentationModel.prototype.reset = function () {
            var _this = this;
            _.forEach(this._modelDefinition.getFields(), function (fieldDef) {
                if (!fieldDef.subResource) {
                    _this.$model[fieldDef.name] = _this._originalModel[fieldDef.name];
                }
            });
        }

        /**
         * Check model is modified. Checks only dirtiness of own fields that can actually be saved on server.
         */
        RepresentationModel.prototype.isDirty = function (fieldName) {
            var _this = this;
            return _.any(_this._modelDefinition.getFields(),
                function (fieldDef) {
                    return !fieldDef.subResource &&
                        (!fieldName || fieldName === fieldDef.name) &&
                        !_.isEqual(_this._originalModel[fieldDef.name], _this.$model[fieldDef.name]);
                });
        }

        /**
         * Check model is new (created on client-side and not saved yet)
         */
        RepresentationModel.prototype.isNew = function () {
            return !this._serverObject;
        }

        /**
         * Validate model
         * @returns {Array} Array of the validation errors
         */
        RepresentationModel.prototype.validate = function () {
            return []; // todo
        }

        /**
         * Is model valid. Note, that this function executes full validation cycle
         * @returns {boolean}
         */
        RepresentationModel.prototype.isValid = function () {
            return true; // todo
        }

        /**
         * Validate field
         * @param {string} fieldName name of the field
         * @returns {Array} Array of the validation errors
         */
        RepresentationModel.prototype.validateField = function (fieldName) {
            return []; // todo
        }

        /**
         * Full unRest clone of current model. Result will contain plain objects tree only
         * @returns {Object}
         */
        RepresentationModel.prototype.unRestClone = function () {
            return plainCloneRecursive(this.$model, {});
        }


        /**
         * Recursive unRest cloning function
         * @param {Array|Object} original original object
         * @param {Array|Object} target destination object
         * @returns {Array|Object} target object
         */
        function plainCloneRecursive(original, target) {
            _.forEach(original, function (value, key) {
                if (value && _.isArray(value)) {
                    target[key] = plainCloneRecursive(value, []);
                } else if (value && value.isRepresentationModel) {
                    target[key] = plainCloneRecursive(value.$model, {});
                } else {
                    target[key] = _.cloneDeep(value);
                }
            });
            return target;
        }

        return (RepresentationModel);
    })

;
